import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=64cee429&scoped=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&id=64cee429&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cee429",
  null
  
)

export default component.exports